var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruoraLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 29,
    viewBox: "0 0 107 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4604_24064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0361 0.00146484C13.9455 0.039848 9.79079 4.09678 9.61781 9.19819H9.53516V28.5244C13.462 28.5235 16.9832 26.0991 18.3941 22.4247C18.3096 22.4247 18.2231 22.4247 18.1366 22.4247C16.0808 22.4274 14.1985 21.2697 13.2691 19.4311C12.3397 17.5925 12.5214 15.3859 13.739 13.7251C14.9566 12.0642 17.0028 11.2318 19.0304 11.5725V9.51426H19.1053C24.3208 9.47827 28.5311 5.231 28.5352 0.00146484H19.0361Z",
    fill: "url(#paint0_linear_4604_24064)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7352 19.9123L16.1068 18.3957C15.719 18.0346 15.49 17.5334 15.4702 17.0024C15.4503 16.4715 15.6413 15.9545 16.0011 15.5652L17.7794 17.2229L22.5856 13.1231C23.4276 12.4063 24.6866 12.5037 25.4097 13.3414L17.7352 19.9123Z",
    fill: "url(#paint1_linear_4604_24064)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47396 0.00146484C4.27207 0.0436255 0.0770544 4.27592 0.0761719 9.48278H18.9159V0.00146484H9.47396Z",
    fill: "url(#paint2_linear_4604_24064)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.637 16.5923C12.6678 16.5902 12.6718 16.3305 12.7362 15.9561C12.7745 15.7334 12.8405 15.469 12.929 15.197C13.079 14.7365 13.3229 14.2413 13.6352 13.7906C13.7856 13.5736 13.9543 13.3677 14.1312 13.1792C14.2542 13.0481 14.3802 12.9253 14.5106 12.8141C14.6944 12.6573 14.8797 12.5141 15.0702 12.3866C15.6227 12.0166 16.205 11.7681 16.8123 11.6213C17.1232 11.5462 17.5527 11.4662 18.1058 11.4692C18.2248 11.4698 18.3989 11.4729 18.6239 11.4953C18.6967 11.5026 18.8175 11.5189 18.9865 11.5442C18.9778 10.1938 18.9778 9.5126 18.9865 9.50052C19.7614 8.42689 22.1595 8.77118 22.7679 8.54733C22.8913 8.50192 22.8293 7.841 22.8293 7.47994C22.8293 4.39124 21.3037 1.65978 18.9668 0.00155228C17.3939 0.00135554 11.8428 0.00155228 9.32598 0.00155228C8.99876 0.00928987 8.51355 0.0757036 8.31295 0.0853862C6.04166 1.7508 4.56641 4.44264 4.56641 7.47994C4.56641 8.17336 4.79127 8.8455 5.24101 9.49636C5.6578 9.49636 7.08204 9.49636 9.51373 9.49636C9.51373 11.2591 9.51373 12.3137 9.51373 12.6601C9.51373 13.8055 9.51373 15.1215 9.51373 15.6179C10.6634 16.2159 11.6221 16.534 12.4183 16.5851C12.4928 16.5899 12.5658 16.5971 12.637 16.5923Z",
    fill: "url(#paint3_radial_4604_24064)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0361 0.00146484C13.9455 0.0397905 9.79079 4.09063 9.61781 9.18439L9.53516 18.8061C9.53516 13.6718 13.6925 9.50961 18.8209 9.50961H19.0304H19.1053C24.3246 9.47364 28.5364 5.22691 28.5352 0.00146484H19.0361Z",
    fill: "url(#paint4_linear_4604_24064)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.848 8.53809H41.6451V19.505C41.6429 21.471 40.0522 23.0642 38.0894 23.0664V8.53809H32.5801C32.5801 6.70002 34.0677 5.20996 35.9028 5.20996H47.1708C47.1708 7.04804 45.6832 8.53809 43.848 8.53809Z",
    fill: "#1C1C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6697 10.6121L55.1757 13.9059C54.5384 13.6429 53.8566 13.5044 53.1672 13.4977C51.6282 13.4977 50.5709 14.4406 50.5709 16.2732V19.665C50.572 20.5458 50.2228 21.3909 49.6002 22.0141C48.9777 22.6373 48.1329 22.9875 47.252 22.9875V10.6774H50.4688V12.0243C51.2445 10.8651 52.4283 10.3467 53.9429 10.3467C54.5295 10.3349 55.1137 10.4246 55.6697 10.6121Z",
    fill: "#1C1C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1072 10.6121L92.6094 13.9059C91.9724 13.643 91.2909 13.5044 90.6019 13.4978C89.0636 13.4978 88.0068 14.4406 88.0068 16.2733V19.665C88.0079 20.5458 87.6588 21.3909 87.0366 22.0141C86.4144 22.6373 85.57 22.9875 84.6895 22.9875V10.6774H87.9088V12.0243C88.6841 10.8652 89.8633 10.3468 91.3771 10.3468C91.9648 10.3346 92.5501 10.4244 93.1072 10.6121Z",
    fill: "#1C1C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6517 17.8129C68.6517 21.7043 65.9143 23.3825 62.8476 23.3825C59.7808 23.3825 57.0312 21.7043 57.0312 17.8129V10.7407H60.3461V17.523C60.3461 19.4952 61.4199 20.2955 62.8516 20.2955C64.2833 20.2955 65.3612 19.4789 65.3612 17.523V10.7448H68.6557L68.6517 17.8129Z",
    fill: "#1C1C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.487 22.9868H103.244V21.6252C102.349 22.7296 100.986 23.3503 99.563 23.3007C96.1603 23.3007 93.5879 20.5203 93.5879 16.8267C93.5879 13.1331 96.1603 10.3486 99.563 10.3486C100.989 10.2975 102.355 10.9238 103.244 12.0364C103.246 11.286 103.857 10.6788 104.61 10.6788H106.495L106.487 22.9868ZM96.966 16.8267C96.966 18.7061 98.1929 20.2146 100.152 20.2146C102.111 20.2146 103.338 18.7673 103.338 16.8267C103.338 14.8861 102.054 13.4348 100.152 13.4348C98.2502 13.4348 96.966 14.9432 96.966 16.8267Z",
    fill: "#1C1C1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7032 10.5038C77.5695 10.4972 78.428 10.6693 79.2252 11.0094C79.9906 11.3384 80.6874 11.8086 81.2794 12.3957C81.8669 12.9868 82.3351 13.6859 82.6583 14.4547C82.9993 15.2534 83.1723 16.1139 83.1668 16.9826C83.1728 17.8461 82.9996 18.7014 82.6583 19.4942C82.3311 20.2609 81.8634 20.9594 81.2794 21.5533C80.6922 22.1493 79.9944 22.6243 79.2252 22.9518C77.6122 23.6314 75.7942 23.6314 74.1812 22.9518C73.4193 22.622 72.7285 22.1471 72.1473 21.5533C71.5633 20.9594 71.0956 20.2609 70.7684 19.4942C70.4271 18.7014 70.2539 17.8461 70.2599 16.9826C70.2544 16.1139 70.4275 15.2534 70.7684 14.4547C71.0917 13.6859 71.5599 12.9868 72.1473 12.3957C72.7333 11.8107 73.4231 11.3406 74.1812 11.0094C74.9784 10.6693 75.8368 10.4972 76.7032 10.5038ZM76.7032 13.5496C75.7984 13.5321 74.9267 13.8907 74.2951 14.5403C73.6355 15.181 73.269 16.0662 73.2822 16.9867C73.2803 17.4312 73.3704 17.8713 73.5466 18.2792C73.7301 18.6932 73.9833 19.0725 74.2951 19.4005C74.9239 20.057 75.7952 20.4243 76.7032 20.4157C77.1511 20.4172 77.5948 20.3299 78.0089 20.1588C78.4269 19.9891 78.803 19.7303 79.1113 19.4005C80.0917 18.4234 80.3873 16.95 79.8597 15.6691C79.3322 14.3882 78.0857 13.5529 76.7032 13.5536V13.5496Z",
    fill: "#1C1C1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4604_24064",
    x1: 8.95852,
    y1: 1426.15,
    x2: 1909.54,
    y2: 1426.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6300FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0000FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4604_24064",
    x1: 15.6432,
    y1: 375.931,
    x2: 1009.18,
    y2: 375.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6300FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0000FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4604_24064",
    x1: -0.11562,
    y1: 473.395,
    x2: 1883.85,
    y2: 473.395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6300FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0000FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4604_24064",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(874.61 851.495) scale(917.579 917.584)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030238"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4500FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4604_24064",
    x1: 8.95852,
    y1: 939.462,
    x2: 1909.54,
    y2: 939.462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6300FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0000FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4604_24064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 29,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruoraLogo);
export default __webpack_public_path__ + "static/media/truora_logo.b4e3a43167c8ffbb3a04ecf82852b1b9.svg";
export { ForwardRef as ReactComponent };